import React, { useEffect, useState } from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import masterServices from "../../Services/masterService";
import locationServices from "../../Services/locationServices";
import Loader from "../../Components/Loader";

const freightTypeList = [
  { value: "Air_Freight", label: "Air Freight" },
  { value: "Sea_Freight", label: "Sea Freight" },
  { value: "Courier_Freight", label: "Courier Freight" },
  { value: "Land_Freight", label: "Land Freight" },
];

export const EditProfitMargin = () => {
  const history = useHistory();
  const param = history.location.state;
  const [loader, setLoader] = useState(false);
  const [countryList, setCountryList] = useState([]);
  // eslint-disable-next-line
  const [list, setList] = useState({});
  // const [initialValue, setInitialValue] = useState();
  // const [countryValue, setCountryValue] = useState("");

  const [freightType, setFreightType] = useState({
    value: param.freight_type,
    label: param.freight_type,
  });

  useEffect(() => {
    getCountryList();
  }, []);

  let listLocal = [];
  // eslint-disable-next-line
  param.freight_data.map((element, j) => {
    // eslint-disable-next-line
    element.value_of_goods.map((elem, i) => {
      listLocal.push({
        freight_from: element.freight_from,
        freight_to: element.freight_to,
        min_goods: elem.min_goods,
        max_goods: elem.max_goods,
        profit: elem.profit,
        min_profit: elem.min_profit,
      });
    });
  });

  const initialValues = {
    country_id: param.country_id,
    freight_type: param.freight_type,
    freight_data: listLocal,
    id: param._id,
    list: list,
  };

  const validationSchema = Yup.object().shape({
    country_id: Yup.string().required("Required"),
    freight_type: Yup.string().required("Required"),
    freight_data: Yup.array().of(
      Yup.object().shape({
        // minimum: Yup.string().required("Required"),
        // percentage: Yup.number()
        //   .typeError("Must be a number")
        //   .required("Required")
        //   .max(100, "should be lessthen 100"),
        freight_from: Yup.string().required("Required"),
        freight_to: Yup.string().required("Required"),
        min_goods: Yup.string().required("Required"),
        max_goods: Yup.string().required("Required"),
        profit: Yup.string().required("Required"),
        min_profit: Yup.string().required("Required"),
      })
    ),
  });

  const onAddFreightData = (errors, values, setValues) => {
    const freight_data = [...values.freight_data];
    if (errors && errors.freight_data !== undefined) {
      toast.error("fill initial freight data");
    } else {
      freight_data.push({
        freight_from: "",
        freight_to: "",
        min_goods: "",
        max_goods: "",
        profit: "",
        min_profit: "",
        // freight_from: "",
        // //  freight_data[freight_data.length - 1].freight_from + (freight_data[freight_data.length - 1].freight_to - freight_data[freight_data.length - 1].freight_from) + 1,
        // freight_to: "",
        // // freight_data[freight_data.length - 1].freight_to + (freight_data[0].freight_to - freight_data[0].freight_from),
        // // value_of_goods: [{ max_goods: '', min_goods: '', min_profit: '', profit: '' }]
      });
      setValues({ ...values, freight_data });
    }
  };

  const onRemoveFreightData = (values, setValues) => {
    const freight_data = [...values.freight_data];
    freight_data.pop();
    setValues({ ...values, freight_data });
  };

  const onSubmit = (fields) => {
    setLoader(true);
    let postdata = [];
    // eslint-disable-next-line
    fields.freight_data.map((elem) => {
      postdata.push({
        compare: elem.freight_from + "-" + elem.freight_to,
        freight_from: elem.freight_from,
        freight_to: elem.freight_to,
        min_goods: elem.min_goods,
        max_goods: elem.max_goods,
        profit: elem.profit,
        min_profit: elem.min_profit,
      });
    });
    ////////////////////test////////////////////
    var array = [];
    for (let elem of fields.freight_data) {
      array.push({
        compare: elem.freight_from + "-" + elem.freight_to,
        freight_from: elem.freight_from,
        freight_to: elem.freight_to,
        min_goods: elem.min_goods,
        max_goods: elem.max_goods,
        profit: elem.profit,
        min_profit: elem.min_profit,
      });
    }

    var output = [];
    // eslint-disable-next-line
    array.forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.compare === item.compare;
      });
      if (existing.length) {
        var existingIndex = output.indexOf(existing[0]);
        output[existingIndex].value_of_goods = output[
          existingIndex
        ].value_of_goods.concat({
          profit: item.profit,
          min_profit: item.min_profit,
          min_goods: item.min_goods,
          max_goods: item.max_goods,
        });
      } else {
        if (typeof item.compare == "string")
          //item.profit = [item.profit];
          item.value_of_goods = [
            {
              profit: item.profit,
              min_profit: item.min_profit,
              min_goods: item.min_goods,
              max_goods: item.max_goods,
            },
          ];
        output.push(item);
      }
    });
    let postData = {
      freight_type: fields.freight_type,
      freight_data: output,
      country_id: countryList.filter(
        (list) => list.country_currency === "AED"
      )[0]._id,
      id: param._id,
    };

    masterServices
      .update_profit_margin(postData)
      .then((res) => {
        if (res.status) {
          history.push("/profit-margin-list");
          toast.success(res.message);
          setLoader(false);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  // const onSelectCountry = (e, values, setValues) => {
  //   setCountryValue(e);
  //   setValues({ ...values, country_id: e.value });
  // };

  const onSelectFreightType = (e, values, setValues) => {
    setFreightType(e);
    setValues({ ...values, freight_type: e.value });
  };

  const getCountryList = () => {
    setLoader(true);
    locationServices.getCountry({ page: 1, limit: 300 }).then((res) => {
      if (res.status) {
        setCountryList(res.data);
        setLoader(false);
      }
    });
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-7">
        <div className="card">
          <div className="card-body">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ errors, values, touched, setValues, setFieldError }) => (
                <Form className="control-form">
                  <div className="row px-1">
                    <div className="mb-2 d-flex">
                      <div className="col-4 pe-2">
                        <label className="form-label m-2 ms-0">
                          Freight Type :{" "}
                        </label>
                        {/* <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: errors.freight_type
                                ? !errors.freight_type
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          value={freightType}
                          // disabled
                          onChange={(e) =>
                            onSelectFreightType(e, values, setValues)
                          }
                          options={freightTypeList}
                          isDisabled
                        /> */}

                        <Select
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "35px", // Set your desired height
                              height: "35px", // Ensure consistency
                              borderColor: errors.freight_type
                                ? !errors.freight_type
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: state.isFocused
                                ? "0 0 0 2px rgba(52, 195, 143, 0.5)"
                                : "none",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0px 5px", // Adjust padding for better alignment
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: "#a0b0ca",
                            }),
                          }}
                          value={freightType}
                          onChange={(e) =>
                            onSelectFreightType(e, values, setValues)
                          }
                          options={freightTypeList}
                          isDisabled
                        />

                        <ErrorMessage
                          name="freight_type"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      {(param.min_shipment_per_month ||
                        param.min_shipment_per_month === 0) && (
                        <div className="col-4 pe-2">
                          <label className="form-label m-2">
                            Min Shipment Per Month :{" "}
                          </label>
                          <Field
                            name="min_shipment_per_month"
                            type="number"
                            min={0}
                            // disabled={i !== 0}
                            value={param.min_shipment_per_month}
                            //  onBlur={() => initialFreightEvent(errors, values, setValues, setFieldError)}
                            className={
                              "form-control"
                              //  +
                              // (ticketErrors.freight_from &&
                              // ticketTouched.freight_from
                              //   ? " is-invalid"
                              //   : "")
                            }
                            disabled
                          />
                        </div>
                      )}

                      {(param.min_revenue_per_month ||
                        param.min_revenue_per_month === 0) && (
                        <div className="col-4">
                          <label className="form-label m-2">
                            Min Revenue Per Month :{" "}
                          </label>
                          <Field
                            name="min_revenue_per_month"
                            type="number"
                            min={0}
                            // disabled={i !== 0}
                            value={param.min_revenue_per_month}
                            //  onBlur={() => initialFreightEvent(errors, values, setValues, setFieldError)}
                            className={
                              "form-control"
                              //  +
                              // (ticketErrors.freight_from &&
                              // ticketTouched.freight_from
                              //   ? " is-invalid"
                              //   : "")
                            }
                            disabled
                          />
                        </div>
                      )}
                    </div>
                    <div className="table-responsive mb-2">
                      <table className="table table-centered table-nowrap mb-0 table-bordered text-center">
                        <thead className="table-light">
                          <tr>
                            {/* <th>S no.</th> */}
                            <th>Freight Amount Range ( AED )</th>
                            <th>Value Of Goods</th>
                            <th>Profit %</th>
                            <th>Minimum Profit Margin</th>
                          </tr>
                        </thead>
                        <tbody>
                          <FieldArray name="freight_data">
                            {() =>
                              values.freight_data.map((ticket, i) => {
                                const ticketErrors =
                                  (errors.freight_data?.length &&
                                    errors.freight_data[i]) ||
                                  {};
                                const ticketTouched =
                                  (touched.freight_data?.length &&
                                    touched.freight_data[i]) ||
                                  {};
                                return (
                                  <tr key={i} className="edit-profit-table">
                                    <td className="d-flex justify-content-around align-middle">
                                      <Field
                                        name={`freight_data.${i}.freight_from`}
                                        type="number"
                                        min={0}
                                        // disabled={i !== 0}
                                        value={ticket.freight_from}
                                        //  onBlur={() => initialFreightEvent(errors, values, setValues, setFieldError)}
                                        className={
                                          "form-control" +
                                          (ticketErrors.freight_from &&
                                          ticketTouched.freight_from
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      &nbsp;
                                      <Field
                                        name={`freight_data.${i}.freight_to`}
                                        type="number"
                                        // disabled={i !== 0}
                                        //  onBlur={() => initialFreightEvent(errors, values, setValues, setFieldError)}
                                        value={ticket.freight_to}
                                        className={
                                          "form-control" +
                                          (ticketErrors.freight_to &&
                                          ticketTouched.freight_to
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-around align-middle pwidth">
                                        {" "}
                                        <Field
                                          name={`freight_data.${i}.min_goods`}
                                          type="number"
                                          min={0}
                                          // disabled={i !== 0}
                                          value={ticket.min_goods}
                                          //  onBlur={() => initialFreightEvent(errors, values, setValues, setFieldError)}
                                          //   className={"form-control"}
                                          className={
                                            "form-control" +
                                            (ticketErrors.min_goods &&
                                            ticketTouched.min_goods
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        &nbsp;
                                        <Field
                                          name={`freight_data.${i}.max_goods`}
                                          type="number"
                                          // disabled={i !== 0}
                                          //  onBlur={() => initialFreightEvent(errors, values, setValues, setFieldError)}
                                          value={ticket.max_goods}
                                          className={
                                            "form-control" +
                                            (ticketErrors.max_goods &&
                                            ticketTouched.max_goods
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <Field
                                        name={`freight_data.${i}.profit`}
                                        type="number"
                                        value={ticket.profit}
                                        // max="100"
                                        className={
                                          "form-control" +
                                          (ticketErrors.profit &&
                                          ticketTouched.profit
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name={`freight_data.${i}.percentage`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </td>
                                    <td>
                                      <Field
                                        name={`freight_data.${i}.min_profit`}
                                        type="number"
                                        value={ticket.min_profit}
                                        className={
                                          "form-control" +
                                          (ticketErrors.min_profit &&
                                          ticketTouched.min_profit
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                    </td>
                                  </tr>
                                );
                              })
                            }
                          </FieldArray>
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p
                        className="text-primary pointer"
                        onClick={() =>
                          onAddFreightData(errors, values, setValues)
                        }
                      >
                        + Add More Freight Data
                      </p>

                      {values && values.freight_data.length > 1 && (
                        <p
                          className="text-danger pointer"
                          onClick={() => onRemoveFreightData(values, setValues)}
                        >
                          - Remove Last Freight Data
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="mt-3 d-flex justify-content-between">
                      <button
                        className="btn btn-danger w-sm waves-effect waves-light"
                        type="button"
                        onClick={() => history.goBack()}
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-primary w-sm waves-effect waves-light"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
